import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { MOUNT } from "./mount";
// Side-effecting: the i18next singleton has to be initialised before the
// first component calls useTranslation, or the tree renders once with raw
// keys and then flips.
import "./i18n";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* The prefix the browser is actually using, not the one baked at
        build time - the app is reachable both under /hil/ and at the
        root of its own subdomain. See ./mount. */}
    <BrowserRouter basename={MOUNT || "/"}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
